<template>
  <div id="app">
    <router-view v-if="isAuthPage" />

    <template v-else>
      <Transition name="fade-backdrop">
        <div v-if="isSidebarOpen" class="sidebar-backdrop" @click="closeSidebar"></div>
      </Transition>
      <AdminSidebar
        :is-open="isSidebarOpen"
        :auth-user-email="authUserEmail"
        :auth-user-name="authUserName"
        :auth-user-role="authUserRole"
        :auth-user-image="authUserImage"
        :auth-user-initials="authUserInitials"
        @logout="logout"
        @navigate="closeSidebar"
      />
      <main class="admin-main">
        <div class="topbar" :class="{ 'topbar-bare': hasOwnPageHead }">
          <div class="topbar-head">
            <router-link class="topbar-logo mobile-only" to="/" aria-label="На главную">
              <img :src="logoUrl" alt="Optometry Clinic" />
            </router-link>
            <template v-if="!hasOwnPageHead">
              <div class="topbar-start">
                <p class="eyebrow">Clinic Admin</p>
                <h1>{{ pageTitle }}</h1>
              </div>
              <button
                class="btn btn-outline-primary topbar-refresh"
                type="button"
                :disabled="isRefreshing || !isAuthenticated"
                @click="refreshData"
              >
                <span v-if="isRefreshing" class="spinner-border spinner-border-sm"></span>
                <span v-else class="fas fa-sync-alt"></span>
                <span class="topbar-refresh-text">Обновить</span>
              </button>
            </template>
            <div class="topbar-quick-links mobile-only">
              <router-link
                v-for="link in quickLinks"
                :key="link.to"
                class="btn btn-outline-secondary topbar-quick-link"
                :to="link.to"
                :title="link.label"
                :aria-label="link.label"
              >
                <span class="fas" :class="link.icon"></span>
              </router-link>
            </div>
            <button class="btn btn-outline-secondary topbar-toggle mobile-only" type="button" @click="toggleSidebar">
              <span class="fas" :class="isSidebarOpen ? 'fa-times' : 'fa-bars'"></span>
            </button>
          </div>
        </div>
        <router-view />
      </main>
    </template>
    <ConfirmModal />
    <ActivityIndicator />
    <NotificationStack />
  </div>
</template>

<script>
import logoUrl from './assets/Images/logo.svg'
import AdminSidebar from './components/AdminSidebar.vue'
import ConfirmModal from './components/ConfirmModal.vue'
import ActivityIndicator from './components/ActivityIndicator.vue'
import NotificationStack from './components/NotificationStack.vue'

export default {
  components: {
    AdminSidebar,
    ConfirmModal,
    ActivityIndicator,
    NotificationStack
  },
  data() {
    return {
      isSidebarOpen: false,
      logoUrl,
      // Быстрый доступ к заявкам: на мобильном за ними иначе надо лезть в меню.
      quickLinks: [
        { to: '/service-orders', label: 'Заявки на услуги', icon: 'fa-calendar-check' },
        { to: '/shop-orders', label: 'Заявки магазина', icon: 'fa-shopping-bag' }
      ]
    }
  },
  computed: {
    pageTitle() {
      return this.$route.meta.title || 'Admin'
    },
    // Дашборд рисует собственную шапку с приветствием и кнопкой обновления,
    // поэтому общий заголовок над ней был бы дублем.
    hasOwnPageHead() {
      return Boolean(this.$route.meta.ownPageHead)
    },
    isRefreshing() {
      return this.$store.getters.isRefreshing
    },
    isAuthPage() {
      return Boolean(this.$route.meta.public)
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    authUserEmail() {
      const user = this.$store.getters.authUser
      return user ? user.email : ''
    },
    authProfile() {
      return this.$store.getters.authProfile || {}
    },
    authUserRole() {
      return this.authProfile.role || ''
    },
    authUserName() {
      return this.authProfile.name || ''
    },
    authUserImage() {
      return this.authProfile.image || ''
    },
    authUserInitials() {
      return (this.authUserName || this.authUserEmail || 'A').slice(0, 1).toUpperCase()
    },
    db() {
      return this.$store.getters.db
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen
    },
    closeSidebar() {
      this.isSidebarOpen = false
    },
    refreshData() {
      return this.$store.dispatch('refreshAll')
    },
    async logout() {
      const confirmed = await this.$confirm({
        title: 'Выйти из админки?',
        message: 'Вы завершите текущую сессию и вернетесь на страницу входа.',
        confirmText: 'Выйти',
        cancelText: 'Остаться',
        variant: 'danger'
      })

      if (!confirmed) return

      this.$store.dispatch('logout')
        .then(() => this.$router.replace('/login'))
    }
  },
  watch: {
    $route() {
      this.closeSidebar()
    },
    isAuthenticated: {
      immediate: true,
      handler(isAuthenticated) {
        if (isAuthenticated && !this.db) {
          this.$store.dispatch('fetchDb')
        }
        if (!isAuthenticated && !this.isAuthPage) {
          this.$router.replace({
            path: '/login',
            query: this.$route.fullPath && this.$route.fullPath !== '/' ? { redirect: this.$route.fullPath } : {}
          })
        }
      }
    }
  }
}
</script>

<style lang="less">
@import "./assets/less/index.less";
</style>



